import React,{ useState,useEffect,forwardRef,useImperativeHandle } from 'react'
import { Modal,Form,Input,Radio,message } from 'antd';
import { saveMerchant } from "@/services/merchant"
import { ResDataType } from '@/services/ajax';
import { DataType } from '../column';
import usePagAndCommon from '@/hooks/usePagAndCommon';
const MerchantDetail = (props:any,ref:any) => {
    const { save } = props;
    const { curType,setCurType,isModalOpen,setIsModalOpen } = usePagAndCommon();
    const [form] = Form.useForm();
    const [curMerchant,setCurMerchant] = useState<DataType>();

    const showModal = (type:string,row:DataType) => {
        setCurType(type);
        setCurMerchant(row);
        if(type=='edit') {
            form.setFieldsValue(row) 
        } else {
            form.resetFields();
        }
        setIsModalOpen(true);
    };
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const data = {...values,id:curType=='add'? 0 :curMerchant?.id};
            const res = await saveMerchant(data) as ResDataType; 
            if (res.code == 0) {
                message.success(`${curType=='add'?'新增':'保存'}成功`);
                setIsModalOpen(false); 
                save();
            }else {
                message.error(res.message);
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo); 
        } 
    }
    const handleCancel = () => {
        setIsModalOpen(false);
      };

    useImperativeHandle(ref, () => ({
        open: (type:string,row:DataType) => showModal(type,row),
    }))
    return(
        <Modal title={curType == 'add'?'新增商户':'编辑商户'} okText="确定" cancelText="取消" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} >
            <Form
                form={form}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 14 }}
                layout="horizontal"
                style={{ maxWidth: 600 }}
                >
                    <Form.Item label='商户名称' name='name' rules={[{ required: true, message: '请输入商户名称' }]}>
                        <Input placeholder="请输入商户名称" /> 
                    </Form.Item>
                    <Form.Item label='客服IM地址' name='customerServiceUrl' rules={[{ required: true, message: '请输入客服IM地址' }]}>
                        <Input placeholder="请输入客服IM地址" /> 
                    </Form.Item>
            </Form>
        </Modal>
    )
}

export default forwardRef(MerchantDetail)